import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  generatePath,
  matchPath,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { saveDeeplink } from '../../../redux/actions/deeplink';
import { getDisplayId } from '../../../utils/landingClusterUtils';
import AppRoutes from '../../appRoutes';

export const ProtectedRoute = ({
  redirectRoute,
  path,
  exact,
  strict,
  children,
}) => {
  const { userToken } = useSelector((state) => state.persist.session);
  const { pathname, hash, search } = useLocation();
  const { params } = matchPath(
    {
      path,
      exact,
      strict,
    },
    pathname,
  );
  const dispatch = useDispatch();

  if (AppRoutes.LANDING === redirectRoute) {
    const displayId = getDisplayId(params.clusterId);
    params.displayId = displayId || params.clusterId;
  }

  useEffect(() => {
    if (!userToken) {
      dispatch(saveDeeplink({ path: pathname + search + hash }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (userToken) {
    return children;
  }
  return <Navigate to={generatePath(redirectRoute, params)} replace />;
};

ProtectedRoute.defaultProps = {
  redirectRoute: AppRoutes.LOGIN,
  exact: false,
  strict: false,
};

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  redirectRoute: PropTypes.string,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
};
